export default __webpack_public_path__ + "static/media/GHSI Disclosure Policy.ef968cbe.pdf";